import { Injectable, OnDestroy } from "@angular/core";
import {
  DynamicDialogConfig,
  DynamicDialogRef,
  DynamicDialogService,
} from '@kodit/core/shared-ui';
import { RelevantniDokumentPreviewComponent } from '../../../moduli/racun/src/lib/info/relevantni-dokument-preview/relevantni-dokument-preview.component';
import { DialogSize } from '../../../shared-ui/src/lib/dialogs/dynamic-dialog/dynamicdialog-config';
import { forEach } from 'lodash';
import { BehaviorSubject, Subscription } from "rxjs";
import { environment } from '../../../../../apps/core/src/environments/environment';
import { HttpClient } from "@angular/common/http";
import { FiskalniRacunService } from '../../../moduli/maloprodaja/src/lib/fiskalni-racun/fiskalni-racun.service';

@Injectable({
  providedIn: 'root',
})
export class DocumentPreviewService implements OnDestroy {
  private readonly _dialogConfig: DynamicDialogConfig;
  private readonly _subs: Subscription;

  constructor(
    private _httpClient: HttpClient,
    private _dialogService: DynamicDialogService,
    private _fiskalniService: FiskalniRacunService
  ) {

    this._dialogConfig = new DynamicDialogConfig(DialogSize.FULL);
    this._dialogConfig.header = 'Pregled dokumenta';
    this._dialogConfig.maximisable = false;
    //this._dialogConfig.maximized = true;
    this._dialogConfig.hideFooter = true;
    this._subs = new Subscription();
  }

  openDialog(
    actionUrl: string,
    queryParams?: Record<string, any>
  ): DynamicDialogRef {
    this._dialogConfig.data = {
      actionUrl: this._buildUrl(actionUrl, queryParams),
    };

    return this._dialogService.open(
      RelevantniDokumentPreviewComponent,
      this._dialogConfig
    );
  }

  openDialogForPresignedUrl(presignedUrl: string): DynamicDialogRef {
    this._dialogConfig.data = {
      presignedUrl: presignedUrl,
    };

    return this._dialogService.open(
      RelevantniDokumentPreviewComponent,
      this._dialogConfig
    );
  }

  private _buildUrl(
    actionUrl: string,
    queryParams: Record<string, any>
  ): string {
    if (!queryParams || queryParams.length === 0) {
      return actionUrl;
    }

    const params = new URLSearchParams();

    Object.entries(queryParams).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((v) => params.append(key, String(v)));
      } else if (value !== undefined && value !== null) {
        params.append(key, String(value));
      }
    });

    return `${actionUrl}?${params.toString()}`;
  }

  printPresignedUrl(presignedUrl: string) {
   this._subs.add( this._httpClient
      .get(presignedUrl, { responseType: 'blob' })
      .subscribe((blob: Blob) => {
        // Handle the downloaded blob for printing
        this.printBlob(blob);
      }));
  }

  // private printBlob(blob: Blob, fileType: string) {
  //   const url = URL.createObjectURL(blob);
  //
  //   // const iframe = document.createElement('iframe');
  //   // iframe.style.display = 'none';
  //   // iframe.src = url;
  //   // iframe.allowFullscreen = true;
  //   // document.body.appendChild(iframe);
  //   //const printWindow = iframe.contentWindow!.open(url, '_blank');
  //
  //   const printWindow = window.open(url, '_blank');
  //   debugger// Open in a new tab
  //   if (printWindow) {
  //     printWindow.onload = () => {
  //       printWindow.print(); // Trigger print dialog
  //       URL.revokeObjectURL(url); // Clean up the object URL
  //     };
  //   } else {
  //     console.error('Nije moguće otvoriti prozor za štampanje');
  //   }
  // }

  private printBlob(blob: Blob) {
    const url = URL.createObjectURL(blob);

    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';

    iframe.src = url;
    document.body.appendChild(iframe);

    iframe.onload = () => {
      iframe.contentWindow?.focus();
      iframe.contentWindow?.print();

      // setTimeout(() => {
      //   debugger
      //   document.body.removeChild(iframe);
      //   URL.revokeObjectURL(url);
      //   console.log('Pretpostavljen kraj print dijaloga');
      // }, 1000);
    };
  }

  ngOnDestroy() {
    this._subs.unsubscribe();
  }
}

export function ensureFileUrl(content: string): string {
  if (content.includes(environment.apiBaseUrl) || !content.includes("https://")) {
    return encodeURIComponent(content.replace('/', '_'));
  }

  return encodeURIComponent(content);
}
